import AboutUs from "../components/AboutUs/AboutUs";
import AllBlogs from "../components/AllBlogs/AllBlogs";
import BlogDetails from "../components/AllBlogs/BlogDetails/BlogDetails";
import GetAQuote from "../components/GetAQuote/GetAQuote";
import Home from "../components/Home/Home";
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy";
import Specialties from "../components/Specialties/Specialties";
import TermsAndConditions from "../components/TermsAndConditions/TermsAndConditions";
import Layout from "../layout/Layout";

export const Route=[
    {path:"/", element:<Layout><Home/></Layout>  },
    {path:"/about-us", element:<Layout><AboutUs/></Layout>  },
    {path:"/specialties", element:<Layout><Specialties/></Layout>  },
    {path:"/blog", element:<Layout><AllBlogs/></Layout>  },
    {path:"/blog/details", element:<Layout><BlogDetails/></Layout>  },
    {path:"/privacy-policy", element:<Layout><PrivacyPolicy/></Layout> },
    {path:"/Terms-and-conditions", element:<Layout><TermsAndConditions/></Layout> },
    {path:"/get-a-quote", element:<Layout><GetAQuote/></Layout> },


]